
const Footer = () => {
    return (
        <footer className='py-3 w-full rounded-lg mb-4'>
            <div className=' m-auto lg:w-3/4 md:w-full text-center font-semibold'>
                <h5>© 2025 TalentCo HR Services LLP. All Rights Reserved. </h5>
            </div>
        </footer>
    );
}

export default Footer;
